import { SubscriptionLineType } from '../api/subscriptions-api-type';

type ProductInfoViewType = {
  productTitle: string;
  image?: string;
  variantTitle: string;
  originalPrice: number;
  price: number;
  quantity: number;
  variantId: string;
  planId?: string;
  lineId?: string;
  url: string;
  active: boolean;
};

export type ProductItemPickUpType = {
  productTitle: string;
  image?: string;
  variantTitle: string;
  originalPrice: number;
  price: number;
  quantity: number;
  variantId: string;
  planId?: string;
  lineId?: string;
  url: string;
  active: boolean;
  message?: string;
};

export type { ProductInfoViewType };

export const createProductInfo = (line: SubscriptionLineType, active: boolean): ProductInfoViewType => {
  return {
    productTitle: line.title,
    image: line.variantImage,
    variantTitle: line.variantTitle,
    originalPrice: line.lineDiscountedPriceAmount,
    price: line.currentPriceAmount,
    quantity: line.quantity,
    variantId: line.variantId,
    lineId: line.lineId,
    url: line.onlineStorePreviewUrl,
    active,
  };
};
